function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Info circle"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,4a8,8,0,1,0,8,8A8,8,0,0,0,12,4Zm1,3a1,1,0,0,0-2,0,1,1,0,0,0,2,0Zm0,10V10a1,1,0,0,0-2,0v7a1,1,0,0,0,2,0Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  x: 0,
  y: 39,
  fill: "#3D3D3D",
  fontSize: "5px",
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "\n    Created by Kmg Design\n  ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 0,
  y: 44,
  fill: "#3D3D3D",
  fontSize: "5px",
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "\n    from the Noun Project\n  ");

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 30",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.08992adc.svg";
export { ForwardRef as ReactComponent };